import { Game } from 'config/types/game'
import { RowCenter } from 'layout/Components/Row'
import React from 'react'
import styled from 'styled-components'
import { Icons } from 'svgs'
import { colors } from 'theme/colors'
import Box from 'UIKit/Box/Box'
import OpenEffect from 'UIKit/OpenEffect'
import Text from 'UIKit/Text'

const GameItemActions: React.FC<{ game: Game }> = ({ game }) => {
  return (
    <OpenEffect>
      {game.rtp && (
        <Text
          fontSize="14px"
          fontWeight={700}
          style={{
            textShadow: '1px 1px 1px rgba(0, 0, 0, 0.54)',
            position: 'absolute',
            top: '0px',
            left: '0px',
          }}
          textAlign="left"
          p="8px"
        >
          RTP {game.rtp}
        </Text>
      )}

      <StyledPlayGame display="flex" width={'32px'} height={'32px'}>
        <RowCenter mx="auto">
          <Icons.PlayAltIcon width="16px" height="16px" fill={`${colors.buttonBackgroundAlt2} !important`} />
        </RowCenter>
      </StyledPlayGame>
    </OpenEffect>
  )
}

const StyledPlayGame = styled(Box)`
  background: ${({ theme: { colors } }) => colors.text};
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme: { radii } }) => radii.tiny} !important;
`

export default GameItemActions
